module.exports = __webpack_public_path__ + "img/imagem-04-detalhada-palmeiras-03.518ab3d3.png";